import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { Heatmapbytypesofanimals } from '../../../components/Grossharvestofproducts/Heatmapbytypesofanimals'; 

const HeatmapbytypesofanimalsPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Тепловая карта по видам животных</title>
            </Helmet>
            <Heatmapbytypesofanimals/>
        
        </>
    );
};

export default HeatmapbytypesofanimalsPage
